import { GET_ALL_ICON_URLS } from '../actions/iconActions';

const initialState = {
	iconUrlsIsRefreshing: false
};

export function icon(state = initialState, action) {
	switch (action.type) {
		case GET_ALL_ICON_URLS.pending:
		{
			return {
				...state,
				iconUrlsIsRefreshing: true
			};
		}

		case GET_ALL_ICON_URLS.fulfilled:
		{
			return {
				...state,
				forecastIcons: action.payload,
				lastError: {},
				iconUrlsIsRefreshing: false
			};
		}

		case GET_ALL_ICON_URLS.rejected:
		{
			return {
				...state,
				forecastIcons: undefined,
				lastError: action.payload,
				iconUrlsIsRefreshing: false
			};
		}
	}

	return state;
}